export default "__VITE_ASSET__BNvaELFz__"